import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SessionStateService {
  private readonly expired$ = new BehaviorSubject<boolean>(false);

  readonly sessionExpired$: Observable<boolean> = this.expired$.asObservable();

  notifyExpired(): void {
    if (!this.expired$.value) {
      this.expired$.next(true);
    }
  }

  clearExpired(): void {
    if (this.expired$.value) {
      this.expired$.next(false);
    }
  }

  isExpired(): boolean {
    return this.expired$.value;
  }
}
